import * as React from 'react';

import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph';
import Text from 'components/Text';
import Tooltip from 'components/Tooltip';
import TooltipTrigger from 'components/TooltipTrigger';

type Props = {
  count: number,
  unitText?: boolean,
};

function getUnitText(count: Number) {
  const unitsRemaining = count === 1 ? 'character left' : 'characters left';
  return count < 0 ? 'characters' : unitsRemaining;
}

const RemainingCharactersCount = ({ count, unitText }: Props) => {
  const hasPaidLongCharacterLimit = CurrentUser.getUser().hasPaidLongCharacterLimit();
  const announcementCharactersLimit = CurrentUser.getUser().getAnnouncementCharactersLimit();

  if (hasPaidLongCharacterLimit && count > 200) {
    const tooltip = (
      <Tooltip>
        Your administrator upgraded to a Remind plan. You can now send announcements up to{' '}
        {announcementCharactersLimit} characters long.
      </Tooltip>
    );

    return (
      <TooltipTrigger tooltip={tooltip}>
        <Glyph name="chat-smile" size="large" color="koala" />
      </TooltipTrigger>
    );
  }

  const textColor = count < 0 ? 'lava' : 'eclipse';
  const displayString = `${count}${unitText ? ' ' + getUnitText(count) : ''}`;

  return (
    <Text color={textColor} size="xxsmall" data-test-selector="character_count">
      {displayString}
    </Text>
  );
};

export default RemainingCharactersCount;
